import React from "react";
import LoaderIcon from "Components/loader/LoaderIcon";
import t from "Utils/translation";
import { Icon, check2 } from "Icons/index";

import cx from "classnames";
import s from "./inputVerify.scss";

export default class InputVerify extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditing: false,
    };
  }

  onChange(e) {
    let val = e.target.value;

    if (val.length > 0) {
      this.setState({ isEditing: true });
    } else {
      this.setState({ isEditing: false });
    }

    this.props.onChange({ [this.props.name]: val });
  }

  handleKeyPress(e) {
    if (e.which === 13) {
      this.onClick();
    }
  }

  onClick() {
    this.props.onClick(this.props.value || "");
  }

  render() {
    let {
      className,
      name,
      label,
      hint,
      helpTooltip,
      id,
      type,
      required,
      disabled,
      isVerified,
      min,
      max,
      maxLength,
      placeholder,
      value,
      errors,
      noRequired = false,
      loading,
      onBlur = () => {},
    } = this.props;

    return (
      <div
        className={cx(className, s.inputContainer, {
          [s.withErrors]: errors,
          [s.required]: required && !noRequired,
          [s.labelHint]: hint,
          [s.isEditing]: this.state.isEditing,
          [s.isVerified]: isVerified,
          [s.disabled]: disabled || isVerified,
        })}
      >
        <div className={s.wrapLabel}>
          <label className={s.label} htmlFor={name}>
            {label}
          </label>

          {helpTooltip && <div className={s.helpTooltip}>{helpTooltip}</div>}
          {hint && <div className={s.hint}>{hint}</div>}
        </div>

        <div className={s.wrapInput}>
          <input
            className={s.input}
            ref={(input) => (this.input = input)}
            id={id}
            type={type}
            onKeyPress={this.handleKeyPress.bind(this)}
            onBlur={onBlur}
            name={name}
            required={required}
            disabled={disabled || isVerified}
            onChange={this.onChange.bind(this)}
            value={value}
            min={min && parseInt(min)}
            max={max && parseInt(max)}
            maxLength={maxLength}
            placeholder={placeholder}
          />

          <div className={s.verifyBtn} onClick={this.onClick.bind(this)}>
            {loading && !isVerified && <LoaderIcon iconSize="1.5rem" color={"#ffffff"} />}
            {!loading && !isVerified && t("button.verify")}
            {!loading && isVerified && <Icon className={s.iconCheck} svg={check2} width="1.5rem" height="1.5rem" />}
          </div>
        </div>
        {errors && <div className={cx(s.errorMsg)}>{errors}</div>}
        {/*<div className={s.msgWrap}>
          {errors && <div className={cx(s.errorMsg)}>{errors}</div>}
          {this.state.isEditing && !isVerified && !errors && (
            <div className={s.helpMsg}>{t("input.verify.message")}</div>
          )}
        </div>*/}
      </div>
    );
  }
}
